module.exports = __webpack_public_path__ + "static/media/eye.ac333821.svg";